import { DropDownItem } from "../components/UIElements";
import { postalAddress } from "../types";

export function isValidSiret(siret: string | undefined): boolean {
    if (!siret) {
        return false;
    }
    let isValid;
    if (siret.length !== 14 || isNaN(Number(siret))) isValid = false;
    else {
        // Donc le SIRET est un numérique à 14 chiffres
        // Les 9 premiers chiffres sont ceux du SIREN (ou RCS), les 4 suivants
        // correspondent au numéro d'établissement
        // et enfin le dernier chiffre est une clef de LUHN.
        let sum = 0;
        let tmp: number;
        for (let cpt = 0; cpt < siret.length; cpt++) {
            if (cpt % 2 === 0) {
                // Les positions impaires : 1er, 3è, 5è, etc...
                tmp = Number(siret.charAt(cpt)) * 2; // On le multiplie par 2
                if (tmp > 9) tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
            } else tmp = Number(siret.charAt(cpt));
            sum += parseInt(tmp.toString(), 10);
        }
        if (sum % 10 === 0) isValid = true;
        // Si la somme est un multiple de 10 alors le SIRET est valide
        else isValid = false;
    }
    return isValid;
}

export function buildStringAdress(adress: postalAddress): string {
    if (!adress) {
        return "";
    }
    const { city, postalCode, street, additionalDetails } = adress;
    return street + " " + additionalDetails + " " + postalCode + " " + city;
}

export const sortAlphabetically = (
    establishmentGroupsOptionsOfDossiers: DropDownItem[]
) => {
    return establishmentGroupsOptionsOfDossiers.sort(function (
        a: DropDownItem,
        b: DropDownItem
    ) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
};
